import styled from "styled-components";
import { colors } from "./colors";

/** A heading inside the drop panel, with its note beside it. */
export const SectionTitle = styled.h3`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.ink};
`;

export const SectionNote = styled.span`
    margin-left: 8px;
    font-size: 12px;
    font-weight: 400;
    color: ${colors.muted};
`;
